// Food data with local SVG image URLs for each food item
const foodData = [
  // Fruits
  {"en": "Apple", "zh": "蘋果", "image": "assets/images/apple.svg", "type": "Fruits"},
  {"en": "Avocado", "zh": "酪梨", "image": "assets/images/avocado.svg", "type": "Fruits"},
  {"en": "Banana", "zh": "香蕉", "image": "assets/images/banana.svg", "type": "Fruits"},
  {"en": "Blueberry", "zh": "藍莓", "image": "assets/images/blueberry.svg", "type": "Fruits"},
  {"en": "Coconut", "zh": "椰子", "image": "assets/images/coconut.svg", "type": "Fruits"},
  {"en": "Fig", "zh": "無花果", "image": "assets/images/fig.svg", "type": "Fruits"},
  {"en": "Grapes", "zh": "葡萄", "image": "assets/images/grapes.svg", "type": "Fruits"},
  {"en": "Kiwifruit", "zh": "奇異果", "image": "assets/images/kiwifruit.svg", "type": "Fruits"},
  {"en": "Lemon/Lime", "zh": "檸檬/青檸", "image": "assets/images/lemon_lime.svg", "type": "Fruits"},
  {"en": "Mango", "zh": "芒果", "image": "assets/images/mango.svg", "type": "Fruits"},
  {"en": "Melon", "zh": "瓜類", "image": "assets/images/melon.svg", "type": "Fruits"},
  {"en": "Orange", "zh": "橙子", "image": "assets/images/orange.svg", "type": "Fruits"},
  {"en": "Papaya", "zh": "木瓜", "image": "assets/images/papaya.svg", "type": "Fruits"},
  {"en": "Peach", "zh": "桃子", "image": "assets/images/peach.svg", "type": "Fruits"},
  {"en": "Pear", "zh": "梨子", "image": "assets/images/pear.svg", "type": "Fruits"},
  {"en": "Pineapple", "zh": "鳳梨", "image": "assets/images/pineapple.svg", "type": "Fruits"},
  {"en": "Plum", "zh": "李子", "image": "assets/images/plum.svg", "type": "Fruits"},
  {"en": "Raspberry", "zh": "覆盆子", "image": "assets/images/raspberry.svg", "type": "Fruits"},
  {"en": "Strawberry", "zh": "草莓", "image": "assets/images/strawberry.svg", "type": "Fruits"},
  {"en": "Watermelon", "zh": "西瓜", "image": "assets/images/watermelon.svg", "type": "Fruits"},
  // Veggies
  {"en": "Artichoke", "zh": "朝鮮薊", "image": "assets/images/artichoke.svg", "type": "Veggies"},
  {"en": "Asparagus", "zh": "蘆筍", "image": "assets/images/asparagus.svg", "type": "Veggies"},
  {"en": "Beet", "zh": "甜菜", "image": "assets/images/beet.svg", "type": "Veggies"},
  {"en": "Bell Pepper", "zh": "甜椒", "image": "assets/images/bell_pepper.svg", "type": "Veggies"},
  {"en": "Broccoli", "zh": "西蘭花", "image": "assets/images/broccoli.svg", "type": "Veggies"},
  {"en": "Brussels Sprouts", "zh": "抱子甘藍", "image": "assets/images/brussels_sprouts.svg", "type": "Veggies"},
  {"en": "Carrot", "zh": "胡蘿蔔", "image": "assets/images/carrot.svg", "type": "Veggies"},
  {"en": "Cauliflower", "zh": "花椰菜", "image": "assets/images/cauliflower.svg", "type": "Veggies"},
  {"en": "Chayote Squash", "zh": "佛手瓜", "image": "assets/images/chayote_squash.svg", "type": "Veggies"},
  {"en": "Cucumber", "zh": "黃瓜", "image": "assets/images/cucumber.svg", "type": "Veggies"},
  {"en": "Eggplant", "zh": "茄子", "image": "assets/images/eggplant.svg", "type": "Veggies"},
  {"en": "Green Beans", "zh": "四季豆", "image": "assets/images/green_beans.svg", "type": "Veggies"},
  {"en": "Mushrooms", "zh": "蘑菇", "image": "assets/images/mushrooms.svg", "type": "Veggies"},
  {"en": "Parsnip", "zh": "歐洲防風草", "image": "assets/images/parsnip.svg", "type": "Veggies"},
  {"en": "Peas", "zh": "豌豆", "image": "assets/images/peas.svg", "type": "Veggies"},
  {"en": "Pumpkin", "zh": "南瓜", "image": "assets/images/pumpkin.svg", "type": "Veggies"},
  {"en": "Spinach", "zh": "菠菜", "image": "assets/images/spinach.svg", "type": "Veggies"},
  {"en": "Squash", "zh": "南瓜類", "image": "assets/images/squash.svg", "type": "Veggies"},
  {"en": "Tomatoes", "zh": "番茄", "image": "assets/images/tomatoes.svg", "type": "Veggies"},
  {"en": "Zucchini", "zh": "意大利青瓜", "image": "assets/images/zucchini.svg", "type": "Veggies"},
  {"en": "Choy Sum", "zh": "菜心", "image": "assets/images/generic_vegetable.svg", "type": "Veggies"},
  {"en": "Chinese Cabbage", "zh": "白菜", "image": "assets/images/generic_vegetable.svg", "type": "Veggies"},
  {"en": "You Mai Cai", "zh": "油麥菜", "image": "assets/images/generic_vegetable.svg", "type": "Veggies"},
  {"en": "Corn", "zh": "粟米", "image": "assets/images/corn.svg", "type": "Veggies"},
  {"en": "Wood Ear Mushroom", "zh": "木耳", "image": "assets/images/generic_vegetable.svg", "type": "Veggies"},
  {"en": "Winter Melon", "zh": "冬瓜", "image": "assets/images/generic_vegetable.svg", "type": "Veggies"},
  {"en": "Zit Gwa", "zh": "節瓜", "image": "assets/images/generic_vegetable.svg", "type": "Veggies"},
  {"en": "Emperor Vegetable", "zh": "皇帝菜", "image": "assets/images/generic_vegetable.svg", "type": "Veggies"},
  {"en": "White Radish", "zh": "白蘿蔔", "image": "assets/images/generic_vegetable.svg", "type": "Veggies"},
  // Grains
  {"en": "Amaranth", "zh": "莧菜", "image": "assets/images/amaranth.svg", "type": "Grains"},
  {"en": "Barley", "zh": "大麥", "image": "assets/images/barley.svg", "type": "Grains"},
  {"en": "Buckwheat", "zh": "蕎麥", "image": "assets/images/buckwheat.svg", "type": "Grains"},
  {"en": "Bulgur", "zh": "碎小麥", "image": "assets/images/bulgur.svg", "type": "Grains"},
  {"en": "Cornmeal", "zh": "玉米粉", "image": "assets/images/cornmeal.svg", "type": "Grains"},
  {"en": "Couscous", "zh": "庫斯庫斯", "image": "assets/images/couscous.svg", "type": "Grains"},
  {"en": "Farro", "zh": "法老小麥", "image": "assets/images/farro.svg", "type": "Grains"},
  {"en": "Freekeh", "zh": "綠小麥", "image": "assets/images/freekeh.svg", "type": "Grains"},
  {"en": "Kamut", "zh": "古小麥", "image": "assets/images/kamut.svg", "type": "Grains"},
  {"en": "Millet", "zh": "小米", "image": "assets/images/millet.svg", "type": "Grains"},
  {"en": "Oatmeal", "zh": "燕麥片", "image": "assets/images/oatmeal.svg", "type": "Grains"},
  {"en": "Potato", "zh": "馬鈴薯", "image": "assets/images/potato.svg", "type": "Grains"},
  {"en": "Quinoa", "zh": "藜麥", "image": "assets/images/quinoa.svg", "type": "Grains"},
  {"en": "Rice", "zh": "米飯", "image": "assets/images/rice.svg", "type": "Grains"},
  {"en": "Rye", "zh": "黑麥", "image": "assets/images/rye.svg", "type": "Grains"},
  {"en": "Sorghum", "zh": "高粱", "image": "assets/images/sorghum.svg", "type": "Grains"},
  {"en": "Spelt", "zh": "斯佩爾特小麥", "image": "assets/images/spelt.svg", "type": "Grains"},
  {"en": "Sweet Potato", "zh": "地瓜", "image": "assets/images/sweet_potato.svg", "type": "Grains"},
  {"en": "Teff", "zh": "畫眉草", "image": "assets/images/teff.svg", "type": "Grains"},
  {"en": "Tortilla", "zh": "玉米餅", "image": "assets/images/tortilla.svg", "type": "Grains"},
  // Protein
  {"en": "Adzuki Beans", "zh": "紅豆", "image": "assets/images/adzuki_beans.svg", "type": "Protein"},
  {"en": "Beef", "zh": "牛肉", "image": "assets/images/beef.svg", "type": "Protein"},
  {"en": "Bison", "zh": "野牛肉", "image": "assets/images/bison.svg", "type": "Protein"},
  {"en": "Black Beans", "zh": "黑豆", "image": "assets/images/black_beans.svg", "type": "Protein"},
  {"en": "Chicken", "zh": "雞肉", "image": "assets/images/chicken.svg", "type": "Protein"},
  {"en": "Chickpeas", "zh": "鷹嘴豆", "image": "assets/images/chickpeas.svg", "type": "Protein"},
  {"en": "Duck", "zh": "鴨肉", "image": "assets/images/duck.svg", "type": "Protein"},
  {"en": "Fava Beans", "zh": "蠶豆", "image": "assets/images/fava_beans.svg", "type": "Protein"},
  {"en": "Ground Meat", "zh": "絞肉", "image": "assets/images/ground_meat.svg", "type": "Protein"},
  {"en": "Kidney Beans", "zh": "腎豆", "image": "assets/images/kidney_beans.svg", "type": "Protein"},
  {"en": "Lamb", "zh": "羊肉", "image": "assets/images/lamb.svg", "type": "Protein"},
  {"en": "Lentils", "zh": "小扁豆", "image": "assets/images/lentils.svg", "type": "Protein"},
  {"en": "Liver", "zh": "肝臟", "image": "assets/images/liver.svg", "type": "Protein"},
  {"en": "Lupini Beans", "zh": "羽扇豆", "image": "assets/images/lupini_beans.svg", "type": "Protein"},
  {"en": "Mung Beans", "zh": "綠豆", "image": "assets/images/mung_beans.svg", "type": "Protein"},
  {"en": "Pinto Beans", "zh": "斑豆", "image": "assets/images/pinto_beans.svg", "type": "Protein"},
  {"en": "Pork", "zh": "豬肉", "image": "assets/images/pork.svg", "type": "Protein"},
  {"en": "Rib Meat", "zh": "肋骨肉", "image": "assets/images/rib_meat.svg", "type": "Protein"},
  {"en": "Turkey", "zh": "火雞", "image": "assets/images/turkey.svg", "type": "Protein"},
  {"en": "White Beans", "zh": "白豆", "image": "assets/images/white_beans.svg", "type": "Protein"},
  // Allergens
  {"en": "Peanut", "zh": "花生", "image": "assets/images/peanut.svg", "type": "Allergens"},
  {"en": "Egg", "zh": "雞蛋", "image": "assets/images/egg.svg", "type": "Allergens"},
  {"en": "Cottage Cheese", "zh": "農家乳酪", "image": "assets/images/cottage_cheese.svg", "type": "Allergens"},
  {"en": "Ricotta", "zh": "意式乳清乾酪", "image": "assets/images/ricotta.svg", "type": "Allergens"},
  {"en": "Soft Cheese", "zh": "軟乳酪", "image": "assets/images/soft_cheese.svg", "type": "Allergens"},
  {"en": "Yogurt", "zh": "優格", "image": "assets/images/yogurt.svg", "type": "Allergens"},
  {"en": "Fatty Fish", "zh": "多脂魚", "image": "assets/images/fatty_fish.svg", "type": "Allergens"},
  {"en": "Sardines", "zh": "沙丁魚", "image": "assets/images/sardines.svg", "type": "Allergens"},
  {"en": "Tuna", "zh": "金槍魚", "image": "assets/images/tuna.svg", "type": "Allergens"},
  {"en": "White Fish", "zh": "白魚", "image": "assets/images/white_fish.svg", "type": "Allergens"},
  {"en": "Clams", "zh": "蛤蜊", "image": "assets/images/clams.svg", "type": "Allergens"},
  {"en": "Crab", "zh": "螃蟹", "image": "assets/images/crab.svg", "type": "Allergens"},
  {"en": "Lobster", "zh": "龍蝦", "image": "assets/images/lobster.svg", "type": "Allergens"},
  {"en": "Shrimp", "zh": "蝦", "image": "assets/images/shrimp.svg", "type": "Allergens"},
  {"en": "Tree Nut", "zh": "樹堅果", "image": "assets/images/tree_nut.svg", "type": "Allergens"},
  {"en": "Pasta", "zh": "義大利麵", "image": "assets/images/pasta.svg", "type": "Allergens"},
  {"en": "Wheat Germ", "zh": "小麥胚芽", "image": "assets/images/wheat_germ.svg", "type": "Allergens"},
  {"en": "Edamame", "zh": "毛豆", "image": "assets/images/edamame.svg", "type": "Allergens"},
  {"en": "Tofu", "zh": "豆腐", "image": "assets/images/tofu.svg", "type": "Allergens"},
  {"en": "Sesame", "zh": "芝麻", "image": "assets/images/sesame.svg", "type": "Allergens"}
];

// Category colors for UI theming
const categoryColors = {
  "Fruits": "#ff6b6b",
  "Veggies": "#4ecdc4",
  "Grains": "#ffe66d",
  "Protein": "#a8e6cf",
  "Allergens": "#ffd93d"
};

// Export the data
export { foodData, categoryColors };
